function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9985 0L21 6.006V24H3V0H14.9985ZM14.3775 1.5H4.5V22.4985H19.5V6.627L14.3775 1.5ZM10.5102 4.4658V5.9643H12.0162V7.4643H9.0057C8.5917 7.4643 8.2542 7.8033 8.2542 8.2173C8.2542 8.6313 8.5917 8.9703 9.0057 8.9703H10.5147C11.7567 8.9703 12.7662 9.9813 12.7662 11.2233C12.7662 12.4653 11.7567 13.4763 10.5147 13.4763H10.5102V14.9748H9.0102V13.4763H7.5042V11.9763H10.5147C10.9287 11.9763 11.2662 11.6373 11.2662 11.2233C11.2662 10.8093 10.9287 10.4703 10.5147 10.4703H9.0057C7.7637 10.4703 6.7542 9.4593 6.7542 8.2173C6.7542 6.9753 7.7637 5.9643 9.0057 5.9643H9.0102V4.4658H10.5102Z",
  fill: "currentColor"
});

var SvgInvoiceIcon = function SvgInvoiceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoiceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InvoiceIcon.dd629a11.svg";
export { ForwardRef as ReactComponent };